import React from "react";
import styles from "./inputfield.module.scss";
import Textfield from "../../Shared/Textfield";
import Proptypes from "prop-types";

const AuthTextField = ({
  heading,
  error,
  icon,
  iconOnClick,
  hideError,

  ...props
}) => {
  return (
    <div className={` ${styles["form_group"]} ${styles["posrelative"]}`}>
      <Textfield
        className={`${styles["form_input"]} ${
          error && props?.touched ? styles["error_textfield"] : ""
        }`}
        error={hideError ? null : error}
        style={{
          height: props?.type === "textarea" ? "auto" : "70px",
        }}
        {...props}
      />
      <div className={styles["heading_container"]}>{heading}</div>
      {icon ? (
        <div
          className={styles["icon_container"]}
          onClick={() => iconOnClick && iconOnClick()}
          role="button"
          onKeyDown={() => {}}
          tabIndex={0}
        >
          <img src={icon} width={24} height={24} alt="icon" />
        </div>
      ) : null}
    </div>
  );
};

AuthTextField.propTypes = {
  heading: Proptypes.string,
  error: Proptypes.string,
  icon: Proptypes.string,
  iconOnClick: Proptypes.func,
  hideError: Proptypes.bool,
};

export default AuthTextField;
